
export default {
  data() {
    return {
      isSticky: false,
      steps: [
        {
          image: "icon-rapport-1.png",
          text: `<strong>Remplissez le formulaire</strong> afin d’obtenir un audit adapté à votre activité.`,
        },
        {
          image: "icon-rapport-2.png",
          text: `<strong>Recevez l’analyse de votre site</strong> par mail pour connaître les forces et faiblesses de votre visibilité en ligne.`,
        },
        {
          image: "icon-rapport-3.png",
          text: `<strong>Boostez votre activité</strong> avec des conseils personnalisés et adaptés à votre métier.`,
        },
      ],
      notes: [
        {
          label: "Référencement",
          note: "A",
          color: "green",
        },
        {
          label: "Liens",
          note: "F",
          color: "red",
        },
        {
          label: "Convivialité",
          note: "A-",
          color: "green",
        },
        {
          label: "Performance",
          note: "A+",
          color: "green",
        },
        {
          label: "Réseaux sociaux",
          note: "D",
          color: "red",
        },
      ],
      audits: [
        `<strong>Les performances générales</strong> de votre site`,
        `<strong>Les mots-clés</strong> sur lesquels votre site est référencé`,
        `<strong>Votre position</strong> dans les résultats de recherche Google`,
        `<strong>Le nombre de clients potentiels</strong> que vous pourrez acquérir en optimisant votre stratégie`,
      ],
      reports: [
        {
          title: "Audit de contenu",
          text: `Analysez l’efficacité de votre <strong>stratégie de référencement</strong> et obtenez une estimation des visites de votre site pour chaque mot-clé.`,
        },
        {
          title: "Audit de performance",
          text: `Analysez la rapidité et la fiabilité de votre site pour une meilleure expérience utilisateur.`,
        },
        {
          title: "Audit de popularité",
          text: `Analysez l’efficacité de votre <strong>stratégie de backlinks</strong> et découvrez combien de sites internet renvoient vers le vôtre.`,
        },
        {
          title: "Audit d’expérience utilisateur",
          text: `Obtenez des données sur l'expérience utilisateur pour un site plus intuitif qui engage vos prospects.`,
        },
      ],
      faq: [
        {
          question: "Qu’est-ce qu'un audit de site internet ?",
          answer: `<p>Un audit de site internet est une <strong>analyse technique de votre site internet</strong> dans son ensemble. Il a pour objectif d'identifier les forces et les faiblesses de votre présence en ligne. Cette démarche comprend généralement l'analyse de divers aspects tels que le <strong>design, l'expérience utilisateur (UX), le référencement naturel (SEO), la performance technique et la sécurité de votre site web.</strong></p>
            <p class="mt-4">Il a pour intérêt de révéler des <strong>opportunités d'amélioration</strong> pour que votre site web soit non seulement plus agréable pour les utilisateurs, mais aussi mieux classé dans les résultats des moteurs de recherche. En identifiant les problèmes techniques, comme les erreurs de chargement ou les liens brisés et en proposant des solutions, l'<strong>audit aide à améliorer la performance</strong> globale de votre site.</p>
            `,
          isCollapsed: false,
        },
        {
          question: "Quand faire un audit de son site web ?",
          answer: `<p>Faire des audits de manière régulière est important pour vérifier si votre site est en bonne santé et compétitif. Voici quelques moments clés où il est particulièrement recommandé de réaliser un audit :</p>
            <ul class="mt-4">
              <li><strong>Après une refonte ou une mise à jour majeure</strong> : Si vous avez récemment modifié l'apparence ou la structure de votre site, un audit peut vous aider à vous assurer que ces changements n'ont pas impacté négativement votre référencement ou l'expérience utilisateur.</li>
              <li><strong>Lorsque les performances du site diminuent</strong> : Si vous remarquez une baisse du trafic, une réduction du temps passé sur le site par les utilisateurs, ou une diminution des conversions, un audit peut identifier les problèmes sous-jacents et proposer des solutions.</li>
              <li><strong>Une fois par an, au minimum</strong> : Même si tout semble fonctionner correctement, la technologie et les standards du web évoluent rapidement.</li>
              <li><strong>Avant une campagne marketing importante</strong> : Assurez-vous que votre site est optimisé avant de lancer une grande campagne pour maximiser son efficacité.</li>
              <li><strong>Lorsque les règles de référencement changent</strong> : Les moteurs de recherche mettent régulièrement à jour leurs algorithmes. Après une mise à jour majeure, un audit peut vous aider à ajuster votre stratégie SEO pour maintenir ou améliorer votre positionnement.</li>
            </ul>
            `,
          isCollapsed: false,
        },
        {
          question: "Pourquoi réaliser un audit ?",
          answer: `<p>La réalisation d'un audit de site internet est essentielle pour plusieurs raisons</p>
            <ul class="mt-4">
              <li><strong>Amélioration du référencement (SEO)</strong> : Un audit peut révéler des problèmes d'optimisation pour les moteurs de recherche, tels que des balises meta manquantes, un contenu dupliqué ou des liens brisés. En corrigeant ces problèmes, vous améliorez le classement de votre site dans les résultats de recherche.</li>
              <li><strong>Optimisation de l'expérience utilisateur (UX)</strong> : Un site web facile à naviguer et agréable est plus susceptible de retenir les visiteurs. L'audit aide à identifier les aspects de l'UX qui nécessitent des améliorations, comme la vitesse de chargement des pages, la clarté de la navigation ou la compatibilité mobile.</li>
              <li><strong>Détection de problèmes techniques</strong> : Un audit technique de site web peut détecter des problèmes invisibles à l'œil nu, comme des erreurs de script, des problèmes de sécurité, ou des temps de réponse lents du serveur.</li>
            </ul>
            <p class="mt-4">En résumé, un audit de votre site internet est un document très intéressant pour analyser l’efficacité de votre stratégie digitale. Que cela soit un <strong>audit de site internet gratuit</strong> ou un audit professionnel plus approfondi, les données obtenues vous permettront d’affirmer votre positionnement sur Google et l’efficacité de votre site internet.</p>
            `,
          isCollapsed: false,
        },
        {
          question: "Comment utiliser l’audit pour améliorer son site web ?",
          answer: `<h3>Étape 1 : Analyser les résultats de l’audit</h3>
            <p>Commencez par une <strong>analyse approfondie du rapport d'audit</strong>. Ce document contient des détails essentiels sur les points forts et les faiblesses de votre site. Prenez le temps de comprendre chaque aspect de l’audit et consultez les recommandations fournies pour savoir où commencer pour améliorer votre site.</p>
            <h3>Étape 2 : Prioriser les problèmes</h3>
            <p>Identifiez et classez les problèmes relevés dans l’audit en fonction de leur urgence et de leur impact potentiel sur les performances de votre site. <strong>Priorisez les actions</strong> à entreprendre pour résoudre les problèmes les plus critiques en premier.</p>
            <h3>Étape 3 : Élaborer un plan d’action</h3>
            <p>Avec les priorités établies, créez un plan d'action détaillé. Ce plan doit inclure des objectifs spécifiques, des délais de mise en œuvre et la répartition des responsabilités pour chaque tâche.</p>
            <h3>Étape 4 : Appliquer les recommandations</h3>
            <p>Procédez à l'implémentation des modifications suggérées par l'audit. Cela peut concerner des ajustements <strong>techniques</strong>, des améliorations de <strong>contenu</strong> ou des changements dans la <strong>structure</strong> et le <strong>design du site</strong>.</p>
            <h3>Étape 5 : Suivi et Évaluation</h3>
            <p>Après avoir apporté les modifications, il est crucial de surveiller leur impact. Utilisez des <strong>outils d'analyse</strong> pour mesurer les améliorations en termes de <strong>trafic, engagement des utilisateurs</strong> et <strong>positionnement SEO</strong>. Ajustez votre stratégie si nécessaire.</p>
            <h3>Étape 6 : Audits Réguliers</h3>
            <p>Enfin, <strong>intégrez des audits réguliers</strong> dans votre routine de maintenance du site web. Cela vous aidera à assurer que votre site continue de répondre aux normes actuelles et aux attentes des utilisateurs.</p>
            `,
          isCollapsed: false,
        },
      ],
    };
  },

  head() {
    return {
      title: "Audit de site internet, outil gratuit et comment le réaliser ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez notre outil gratuit pour l'audit de votre site internet. Guide étape par étape pour réaliser un diagnostic et améliorer votre présence en ligne.",
        },
      ],
    };
  },

  mounted() {
    window.addEventListener("scroll", this.onScroll);
    this.spinGreenCircle();
    this.fadeEffect();
    this.bounceEffect();
  },

  methods: {
    onScroll(e) {
      const header = this.$refs.header;
      const sticky = header.offsetTop;

      if (window.pageYOffset > sticky) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    },

    spinGreenCircle() {
      this.$gsap
        .timeline({
          scrollTrigger: {
            trigger: ".green-circle",
            start: "top 80%",
          },
        })
        .fromTo(
          ".green-circle",
          {
            css: {
              strokeDasharray: "305",
              strokeDashoffset: "305",
            },
          },
          {
            css: {
              strokeDasharray: "305",
              strokeDashoffset: "0",
              transition: "1s ease-out",
            },
            onComplete: () => {
              setTimeout(() => {
                this.$refs.score.classList.add("score-b-final");
              }, 600);
            },
          }
        );
    },

    fadeEffect() {
      const allElements = [".fade-effect", ".fade-effect-2"];
      allElements.forEach((item) => {
        this.$gsap
          .timeline({
            scrollTrigger: {
              trigger: item,
              start: "top 80%",
              once: true,
            },
          })
          .fromTo(
            item,
            {
              opacity: 0,
            },
            {
              opacity: 1,
              stagger: 0.3,
            }
          );
      });
    },

    bounceEffect() {
      this.$CustomEase.create("bounce", ".17,.89,.35,1.51");
      this.$gsap
        .timeline({
          scrollTrigger: ".section-advantages--list-item-note",
          start: "top 80%",
          once: true,
        })
        .fromTo(
          ".section-advantages--list-item-note",
          {
            opacity: 0,
            scale: 0.2,
          },
          {
            stagger: 0.3,
            opacity: 1,
            scale: 1,
            ease: "bounce",
          }
        );
    },
  },
};
